import { render, staticRenderFns } from "./rlzypeople.vue?vue&type=template&id=35a9e152&scoped=true&"
import script from "./rlzypeople.vue?vue&type=script&lang=js&"
export * from "./rlzypeople.vue?vue&type=script&lang=js&"
import style0 from "./rlzypeople.vue?vue&type=style&index=0&id=35a9e152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9e152",
  null
  
)

export default component.exports